// import { App } from "vue";
// import ltATable from "./src/dynamic-table.vue";

// ltATable.install = (app: App) => {
//   app.component(ltATable.name, ltATable);
// };

// export default ltATable;

import { withInstall } from "@/utils/install";
import ATable from "./src/dynamic-table.vue";
ATable.name = "ltATable";
export const ltATable = withInstall(ATable);
export default ltATable;
// export * from "./src/dynamic-table";
